module.exports = __webpack_public_path__ + "img/item_bg.2eafe485.png";